/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import semver from "semver";
import NavbarItem from "./NavbarItem.vue";
import GlobalSearch from "./GlobalSearch.vue";
import ConsentModal from "../shared/ConsentModal.vue";
import UserBadge from "../shared/UserBadge.vue";
import { EVENTS, listen } from "../../utils/notificationEvents";
import { useThemeStore } from "../../stores/theme";

const __vue_script__ = {
  name: "Navbar",
  components: { NavbarItem, GlobalSearch, ConsentModal, UserBadge },
  props: {
    navigation: {
      type: Array,
      required: true,
    },
    signed_in: {
      type: Boolean,
      required: true,
    },
    users_path: {
      type: String,
      default: null,
    },
    profile_path: {
      type: String,
      default: null,
    },
    current_user: {
      type: Object,
      default: null,
    },
    sign_out_path: {
      type: String,
      default: null,
    },
    access_requests: {
      type: Array,
      default: () => [],
    },
    locked_users: {
      type: Array,
      required: false,
      default: () => [],
    },
    consent_config: {
      type: Object,
      required: false,
      default: () => null,
    },
    app_version: {
      type: String,
      required: false,
      default: "0.0.0",
    },
  },
  setup() {
    const themeStore = useThemeStore();
    return { themeStore };
  },
  data() {
    return {
      latestRelease: "",
      currentVersion: this.app_version,
      updateAvailable: false,
      localLockedUsers: [...this.locked_users],
      localAccessRequests: [...this.access_requests],
      cleanupLockout: null,
      cleanupAccessRequest: null,
    };
  },
  computed: {
    isDarkMode() {
      return this.themeStore.isDark;
    },
    notificationCount() {
      return this.localAccessRequests.length + this.localLockedUsers.length;
    },
    userDisplayName() {
      if (!this.current_user) return null;
      return this.current_user.name || this.current_user.email || null;
    },
    myCommentsPath() {
      if (!this.current_user || !this.current_user.id) return null;
      return `/users/${this.current_user.id}/comments`;
    },
  },
  mounted() {
    this.themeStore.init();
    this.fetchLatestRelease();
    this.cleanupLockout = listen(EVENTS.LOCKOUT_CHANGED, this.onLockoutChanged);
    this.cleanupAccessRequest = listen(EVENTS.ACCESS_REQUEST_CHANGED, this.onAccessRequestChanged);
  },
  beforeDestroy() {
    if (this.cleanupLockout) this.cleanupLockout();
    if (this.cleanupAccessRequest) this.cleanupAccessRequest();
  },
  methods: {
    toggleColorMode() {
      this.themeStore.toggle();
    },
    onLockoutChanged(event) {
      const { action, user } = event.detail;
      if (action === "locked") {
        if (!this.localLockedUsers.some((u) => u.id === user.id)) {
          this.localLockedUsers.push({ id: user.id, name: user.name, email: user.email });
        }
      } else if (action === "unlocked") {
        this.localLockedUsers = this.localLockedUsers.filter((u) => u.id !== user.id);
      }
    },
    onAccessRequestChanged(event) {
      const { action, id } = event.detail;
      if (action === "resolved") {
        this.localAccessRequests = this.localAccessRequests.filter((r) => r.id !== id);
      }
    },
    fetchLatestRelease() {
      const owner = "mitre";
      const repo = "vulcan";
      // Uses fetch() intentionally — axios sends X-CSRF-Token globally (FormMixin),
      // which GitHub's CORS policy rejects. fetch() has no global interceptors.
      fetch(`https://api.github.com/repos/${owner}/${repo}/releases/latest`)
        .then((response) => response.json())
        .then((data) => {
          this.latestRelease = data.tag_name.substring(1);
          this.updateAvailable = this.checkUpdateAvailable();
        })
        .catch(() => {
          this.latestRelease = "";
        });
    },
    checkUpdateAvailable() {
      if (!this.latestRelease || this.latestRelease.trim() === "") return false;

      // Use semver.gt to check if latest is greater than current
      // Clean versions by removing 'v' prefix if present
      const latest = this.latestRelease.replace(/^v/, "");
      const current = this.currentVersion.replace(/^v/, "");

      try {
        return semver.gt(latest, current);
      } catch (error) {
        // Silently handle version comparison errors - likely malformed version strings
        // In this case, don't show the update banner
        return false;
      }
    },
  },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        { attrs: { toggleable: "xl", type: "dark", variant: "dark" } },
        [
          _c(
            "b-navbar-brand",
            { attrs: { id: "heading", href: "/" } },
            [
              _c("b-icon", {
                attrs: { icon: "broadcast", "aria-hidden": "true" },
              }),
              _vm._v("\n      VULCAN\n      "),
              _c(
                "b-link",
                {
                  attrs: {
                    href: "https://vulcan.mitre.org/CHANGELOG.html",
                    target: "_blank",
                  },
                },
                [
                  _c("span", { staticClass: "latest-release" }, [
                    _vm._v(_vm._s(_vm.currentVersion)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.signed_in
            ? _c(
                "b-navbar-nav",
                {
                  staticClass:
                    "utility-nav flex-row align-items-center ml-auto mr-2 order-xl-last",
                },
                [
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: {
                        right: "",
                        "no-caret": "",
                        "toggle-class": "position-relative",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function () {
                              return [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "bell",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.notificationCount
                                  ? _c(
                                      "b-badge",
                                      {
                                        staticClass:
                                          "rounded-pill position-absolute",
                                        staticStyle: { top: "0", right: "0" },
                                        attrs: { variant: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.notificationCount) +
                                            "\n          "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2734691553
                      ),
                    },
                    [
                      _vm._v(" "),
                      _vm._l(
                        _vm.localAccessRequests,
                        function (access_request, index) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: "ar-" + index,
                              attrs: {
                                href:
                                  "/projects/" +
                                  access_request.project.id +
                                  "?members=1",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    access_request.user.name +
                                      " has requested access to project " +
                                      access_request.project.name
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.localLockedUsers, function (locked_user) {
                        return _c(
                          "b-dropdown-item",
                          {
                            key: "lu-" + locked_user.id,
                            attrs: { href: "/users?unlock=" + locked_user.id },
                          },
                          [
                            _c("b-icon", {
                              staticClass: "mr-1 text-warning",
                              attrs: { icon: "lock" },
                            }),
                            _vm._v(
                              "\n          " +
                                _vm._s(locked_user.name) +
                                " (" +
                                _vm._s(locked_user.email) +
                                ") account is locked\n        "
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item",
                    {
                      attrs: {
                        "link-classes": "text-light px-2",
                        "aria-label": "Toggle dark mode",
                      },
                      on: { click: _vm.toggleColorMode },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: _vm.isDarkMode ? "sun" : "moon" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "", "no-caret": "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function () {
                              return [
                                _vm.current_user
                                  ? _c("UserBadge", {
                                      attrs: {
                                        name: _vm.userDisplayName,
                                        email: _vm.current_user.email,
                                      },
                                    })
                                  : _c("b-icon", {
                                      attrs: {
                                        icon: "person-circle",
                                        "aria-hidden": "true",
                                      },
                                    }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3340023325
                      ),
                    },
                    [
                      _vm._v(" "),
                      _vm.userDisplayName
                        ? _c(
                            "b-dropdown-text",
                            { staticClass: "text-muted small" },
                            [
                              _c(
                                "div",
                                { staticClass: "font-weight-bold text-body" },
                                [_vm._v(_vm._s(_vm.userDisplayName))]
                              ),
                              _vm._v(" "),
                              _vm.current_user && _vm.current_user.email
                                ? _c("div", [
                                    _vm._v(_vm._s(_vm.current_user.email)),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userDisplayName ? _c("b-dropdown-divider") : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { href: _vm.profile_path } },
                        [_vm._v(" Profile ")]
                      ),
                      _vm._v(" "),
                      _vm.myCommentsPath
                        ? _c(
                            "b-dropdown-item",
                            { attrs: { href: _vm.myCommentsPath } },
                            [_vm._v("\n          My Comments\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.users_path
                        ? _c(
                            "b-dropdown-item",
                            { attrs: { href: _vm.users_path } },
                            [_vm._v(" Manage Users ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            href: _vm.sign_out_path,
                            "data-method": "delete",
                          },
                        },
                        [_vm._v("Sign Out")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.signed_in
            ? _c(
                "b-navbar-nav",
                {
                  staticClass:
                    "flex-row align-items-center ml-auto mr-2 order-xl-last",
                },
                [
                  _c(
                    "b-nav-item",
                    {
                      attrs: {
                        "link-classes": "text-light px-2",
                        "aria-label": "Toggle dark mode",
                      },
                      on: { click: _vm.toggleColorMode },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: _vm.isDarkMode ? "sun" : "moon" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "nav-collapse", "is-nav": "" } },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "mr-auto" },
                [
                  _vm._l(_vm.navigation, function (item) {
                    return [
                      item.children
                        ? _c(
                            "b-nav-item-dropdown",
                            {
                              key: item.name,
                              attrs: {
                                right: "",
                                "no-caret": "",
                                "toggle-class": "nav-item__link",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c("b-icon", {
                                          staticClass: "nav-item__icon",
                                          attrs: {
                                            icon: item.icon,
                                            "aria-hidden": "true",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "nav-item__label" },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _vm._l(item.children, function (child) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: child.name,
                                    attrs: { href: child.link },
                                  },
                                  [
                                    child.icon
                                      ? _c("b-icon", {
                                          staticClass: "mr-2",
                                          attrs: { icon: child.icon },
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      _vm._s(child.name) + "\n            "
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        : _c("NavbarItem", {
                            key: item.name,
                            attrs: {
                              icon: item.icon,
                              link: item.link,
                              name: item.name,
                            },
                          }),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.signed_in
                ? _c("b-nav-form", [_c("GlobalSearch")], 1)
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "text-center",
          attrs: { dismissible: "", fade: "", show: _vm.updateAvailable },
          on: {
            dismissed: function ($event) {
              _vm.updateAvailable = false
            },
          },
        },
        [
          _vm._v(
            "\n    New version: Vulcan " +
              _vm._s(_vm.latestRelease) +
              " is now available!!\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.consent_config && _vm.consent_config.enabled
        ? _c("ConsentModal", { attrs: { config: _vm.consent_config } })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-aed97bc8_0", { source: "\n#heading[data-v-aed97bc8] {\n  font-family: verdana, arial, helvetica, sans-serif;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n/* The utility nav (bell / theme / user menu) sits outside the collapse and\n   is always an expanded row, but Bootstrap only restores dropdown\n   `position: absolute` above the navbar's expand breakpoint (xl) — below it,\n   `.navbar-nav .dropdown-menu` falls back to `position: static` and an open\n   menu inflates the navbar instead of overlaying the page (dropdowns are\n   CSS-positioned inside navbars; BootstrapVue never runs Popper there).\n   Re-apply Bootstrap's own expanded-navbar rule (_navbar.scss) to this\n   always-expanded nav so menus float over content at every width — the same\n   behavior the bare `.navbar-expand` pattern gives Bootstrap's docs-site\n   header. The base `.dropdown-menu` class supplies top: 100% and\n   z-index: 1000.\n\n   Menus anchor to the utility nav itself (Bootstrap's documented\n   `.position-static`-on-the-dropdown-parent pattern) rather than each <li>,\n   so a wide menu (e.g. long notification text) right-aligns to the nav —\n   which hugs the viewport edge — instead of overflowing the left edge of\n   small screens. The bell badge anchors to the toggle link\n   (toggle-class=\"position-relative\"), not the <li>. */\n.utility-nav[data-v-aed97bc8] {\n  position: relative;\n}\n.utility-nav[data-v-aed97bc8] .b-nav-dropdown {\n  position: static;\n}\n.utility-nav[data-v-aed97bc8] .dropdown-menu {\n  position: absolute;\n  right: 0;\n  left: auto;\n  max-width: calc(100vw - 2rem);\n}\n/* Dropdown items are nowrap by default — let long notification strings wrap\n   inside the capped menu width. */\n.utility-nav[data-v-aed97bc8] .dropdown-item {\n  white-space: normal;\n}\n.latest-release[data-v-aed97bc8] {\n  font-size: 0.6em;\n}\n", map: {"version":3,"sources":["app/javascript/components/navbar/App.vue"],"names":[],"mappings":";AAuSA;EACA,kDAAA;EACA,gBAAA;EACA,mBAAA;AACA;;AAEA;;;;;;;;;;;;;;;;;sDAiBA;AACA;EACA,kBAAA;AACA;AACA;EACA,gBAAA;AACA;AACA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;AACA;AACA;kCACA;AACA;EACA,mBAAA;AACA;AAEA;EACA,gBAAA;AACA","file":"App.vue","sourcesContent":["<template>\n  <div>\n    <b-navbar toggleable=\"xl\" type=\"dark\" variant=\"dark\">\n      <b-navbar-brand id=\"heading\" href=\"/\">\n        <b-icon icon=\"broadcast\" aria-hidden=\"true\" />\n        VULCAN\n        <b-link href=\"https://vulcan.mitre.org/CHANGELOG.html\" target=\"_blank\">\n          <span class=\"latest-release\">{{ currentVersion }}</span>\n        </b-link>\n      </b-navbar-brand>\n      <!-- ── Utility controls — OUTSIDE collapse, always visible ── -->\n      <b-navbar-nav\n        v-if=\"signed_in\"\n        class=\"utility-nav flex-row align-items-center ml-auto mr-2 order-xl-last\"\n      >\n        <b-nav-item-dropdown right no-caret toggle-class=\"position-relative\">\n          <template #button-content>\n            <b-icon icon=\"bell\" aria-hidden=\"true\" />\n            <b-badge\n              v-if=\"notificationCount\"\n              variant=\"danger\"\n              class=\"rounded-pill position-absolute\"\n              style=\"top: 0; right: 0\"\n            >\n              {{ notificationCount }}\n            </b-badge>\n          </template>\n          <b-dropdown-item\n            v-for=\"(access_request, index) in localAccessRequests\"\n            :key=\"'ar-' + index\"\n            :href=\"`/projects/${access_request.project.id}?members=1`\"\n          >\n            {{\n              `${access_request.user.name} has requested access to project ${access_request.project.name}`\n            }}\n          </b-dropdown-item>\n          <b-dropdown-item\n            v-for=\"locked_user in localLockedUsers\"\n            :key=\"'lu-' + locked_user.id\"\n            :href=\"`/users?unlock=${locked_user.id}`\"\n          >\n            <b-icon icon=\"lock\" class=\"mr-1 text-warning\" />\n            {{ locked_user.name }} ({{ locked_user.email }}) account is locked\n          </b-dropdown-item>\n        </b-nav-item-dropdown>\n\n        <b-nav-item\n          link-classes=\"text-light px-2\"\n          aria-label=\"Toggle dark mode\"\n          @click=\"toggleColorMode\"\n        >\n          <b-icon :icon=\"isDarkMode ? 'sun' : 'moon'\" />\n        </b-nav-item>\n\n        <b-nav-item-dropdown right no-caret>\n          <template #button-content>\n            <UserBadge v-if=\"current_user\" :name=\"userDisplayName\" :email=\"current_user.email\" />\n            <b-icon v-else icon=\"person-circle\" aria-hidden=\"true\" />\n          </template>\n          <b-dropdown-text v-if=\"userDisplayName\" class=\"text-muted small\">\n            <div class=\"font-weight-bold text-body\">{{ userDisplayName }}</div>\n            <div v-if=\"current_user && current_user.email\">{{ current_user.email }}</div>\n          </b-dropdown-text>\n          <b-dropdown-divider v-if=\"userDisplayName\" />\n          <b-dropdown-item :href=\"profile_path\"> Profile </b-dropdown-item>\n          <b-dropdown-item v-if=\"myCommentsPath\" :href=\"myCommentsPath\">\n            My Comments\n          </b-dropdown-item>\n          <b-dropdown-item v-if=\"users_path\" :href=\"users_path\"> Manage Users </b-dropdown-item>\n          <b-dropdown-divider />\n          <!-- Navigational DELETE (rails-ujs data-method): Devise's HTML flow\n               sets the signed-out flash and redirects straight to the sign-in\n               page, where the Toaster shows it. An ajax DELETE returns 204\n               with no flash — the AC-12(02) logoff message never appears. -->\n          <b-dropdown-item :href=\"sign_out_path\" data-method=\"delete\">Sign Out</b-dropdown-item>\n        </b-nav-item-dropdown>\n      </b-navbar-nav>\n\n      <!-- Dark mode toggle for non-signed-in users — also outside collapse -->\n      <b-navbar-nav\n        v-if=\"!signed_in\"\n        class=\"flex-row align-items-center ml-auto mr-2 order-xl-last\"\n      >\n        <b-nav-item\n          link-classes=\"text-light px-2\"\n          aria-label=\"Toggle dark mode\"\n          @click=\"toggleColorMode\"\n        >\n          <b-icon :icon=\"isDarkMode ? 'sun' : 'moon'\" />\n        </b-nav-item>\n      </b-navbar-nav>\n\n      <b-navbar-toggle target=\"nav-collapse\" />\n\n      <!-- ── Collapsible section — nav links + search ── -->\n      <b-collapse id=\"nav-collapse\" is-nav>\n        <b-navbar-nav class=\"mr-auto\">\n          <template v-for=\"item in navigation\">\n            <b-nav-item-dropdown\n              v-if=\"item.children\"\n              :key=\"item.name\"\n              right\n              no-caret\n              toggle-class=\"nav-item__link\"\n            >\n              <template #button-content>\n                <b-icon :icon=\"item.icon\" aria-hidden=\"true\" class=\"nav-item__icon\" />\n                <span class=\"nav-item__label\">{{ item.name }}</span>\n              </template>\n              <b-dropdown-item v-for=\"child in item.children\" :key=\"child.name\" :href=\"child.link\">\n                <b-icon v-if=\"child.icon\" :icon=\"child.icon\" class=\"mr-2\" />{{ child.name }}\n              </b-dropdown-item>\n            </b-nav-item-dropdown>\n            <NavbarItem\n              v-else\n              :key=\"item.name\"\n              :icon=\"item.icon\"\n              :link=\"item.link\"\n              :name=\"item.name\"\n            />\n          </template>\n        </b-navbar-nav>\n\n        <b-nav-form v-if=\"signed_in\">\n          <GlobalSearch />\n        </b-nav-form>\n      </b-collapse>\n    </b-navbar>\n    <b-alert\n      dismissible\n      fade\n      :show=\"updateAvailable\"\n      class=\"text-center\"\n      @dismissed=\"updateAvailable = false\"\n    >\n      New version: Vulcan {{ latestRelease }} is now available!!\n    </b-alert>\n    <ConsentModal v-if=\"consent_config && consent_config.enabled\" :config=\"consent_config\" />\n  </div>\n</template>\n\n<script>\nimport semver from \"semver\";\nimport NavbarItem from \"./NavbarItem.vue\";\nimport GlobalSearch from \"./GlobalSearch.vue\";\nimport ConsentModal from \"../shared/ConsentModal.vue\";\nimport UserBadge from \"../shared/UserBadge.vue\";\nimport { EVENTS, listen } from \"../../utils/notificationEvents\";\nimport { useThemeStore } from \"../../stores/theme\";\n\nexport default {\n  name: \"Navbar\",\n  components: { NavbarItem, GlobalSearch, ConsentModal, UserBadge },\n  props: {\n    navigation: {\n      type: Array,\n      required: true,\n    },\n    signed_in: {\n      type: Boolean,\n      required: true,\n    },\n    users_path: {\n      type: String,\n      default: null,\n    },\n    profile_path: {\n      type: String,\n      default: null,\n    },\n    current_user: {\n      type: Object,\n      default: null,\n    },\n    sign_out_path: {\n      type: String,\n      default: null,\n    },\n    access_requests: {\n      type: Array,\n      default: () => [],\n    },\n    locked_users: {\n      type: Array,\n      required: false,\n      default: () => [],\n    },\n    consent_config: {\n      type: Object,\n      required: false,\n      default: () => null,\n    },\n    app_version: {\n      type: String,\n      required: false,\n      default: \"0.0.0\",\n    },\n  },\n  setup() {\n    const themeStore = useThemeStore();\n    return { themeStore };\n  },\n  data() {\n    return {\n      latestRelease: \"\",\n      currentVersion: this.app_version,\n      updateAvailable: false,\n      localLockedUsers: [...this.locked_users],\n      localAccessRequests: [...this.access_requests],\n      cleanupLockout: null,\n      cleanupAccessRequest: null,\n    };\n  },\n  computed: {\n    isDarkMode() {\n      return this.themeStore.isDark;\n    },\n    notificationCount() {\n      return this.localAccessRequests.length + this.localLockedUsers.length;\n    },\n    userDisplayName() {\n      if (!this.current_user) return null;\n      return this.current_user.name || this.current_user.email || null;\n    },\n    myCommentsPath() {\n      if (!this.current_user || !this.current_user.id) return null;\n      return `/users/${this.current_user.id}/comments`;\n    },\n  },\n  mounted() {\n    this.themeStore.init();\n    this.fetchLatestRelease();\n    this.cleanupLockout = listen(EVENTS.LOCKOUT_CHANGED, this.onLockoutChanged);\n    this.cleanupAccessRequest = listen(EVENTS.ACCESS_REQUEST_CHANGED, this.onAccessRequestChanged);\n  },\n  beforeDestroy() {\n    if (this.cleanupLockout) this.cleanupLockout();\n    if (this.cleanupAccessRequest) this.cleanupAccessRequest();\n  },\n  methods: {\n    toggleColorMode() {\n      this.themeStore.toggle();\n    },\n    onLockoutChanged(event) {\n      const { action, user } = event.detail;\n      if (action === \"locked\") {\n        if (!this.localLockedUsers.some((u) => u.id === user.id)) {\n          this.localLockedUsers.push({ id: user.id, name: user.name, email: user.email });\n        }\n      } else if (action === \"unlocked\") {\n        this.localLockedUsers = this.localLockedUsers.filter((u) => u.id !== user.id);\n      }\n    },\n    onAccessRequestChanged(event) {\n      const { action, id } = event.detail;\n      if (action === \"resolved\") {\n        this.localAccessRequests = this.localAccessRequests.filter((r) => r.id !== id);\n      }\n    },\n    fetchLatestRelease() {\n      const owner = \"mitre\";\n      const repo = \"vulcan\";\n      // Uses fetch() intentionally — axios sends X-CSRF-Token globally (FormMixin),\n      // which GitHub's CORS policy rejects. fetch() has no global interceptors.\n      fetch(`https://api.github.com/repos/${owner}/${repo}/releases/latest`)\n        .then((response) => response.json())\n        .then((data) => {\n          this.latestRelease = data.tag_name.substring(1);\n          this.updateAvailable = this.checkUpdateAvailable();\n        })\n        .catch(() => {\n          this.latestRelease = \"\";\n        });\n    },\n    checkUpdateAvailable() {\n      if (!this.latestRelease || this.latestRelease.trim() === \"\") return false;\n\n      // Use semver.gt to check if latest is greater than current\n      // Clean versions by removing 'v' prefix if present\n      const latest = this.latestRelease.replace(/^v/, \"\");\n      const current = this.currentVersion.replace(/^v/, \"\");\n\n      try {\n        return semver.gt(latest, current);\n      } catch (error) {\n        // Silently handle version comparison errors - likely malformed version strings\n        // In this case, don't show the update banner\n        return false;\n      }\n    },\n  },\n};\n</script>\n\n<style scoped>\n#heading {\n  font-family: verdana, arial, helvetica, sans-serif;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n/* The utility nav (bell / theme / user menu) sits outside the collapse and\n   is always an expanded row, but Bootstrap only restores dropdown\n   `position: absolute` above the navbar's expand breakpoint (xl) — below it,\n   `.navbar-nav .dropdown-menu` falls back to `position: static` and an open\n   menu inflates the navbar instead of overlaying the page (dropdowns are\n   CSS-positioned inside navbars; BootstrapVue never runs Popper there).\n   Re-apply Bootstrap's own expanded-navbar rule (_navbar.scss) to this\n   always-expanded nav so menus float over content at every width — the same\n   behavior the bare `.navbar-expand` pattern gives Bootstrap's docs-site\n   header. The base `.dropdown-menu` class supplies top: 100% and\n   z-index: 1000.\n\n   Menus anchor to the utility nav itself (Bootstrap's documented\n   `.position-static`-on-the-dropdown-parent pattern) rather than each <li>,\n   so a wide menu (e.g. long notification text) right-aligns to the nav —\n   which hugs the viewport edge — instead of overflowing the left edge of\n   small screens. The bell badge anchors to the toggle link\n   (toggle-class=\"position-relative\"), not the <li>. */\n.utility-nav {\n  position: relative;\n}\n.utility-nav >>> .b-nav-dropdown {\n  position: static;\n}\n.utility-nav >>> .dropdown-menu {\n  position: absolute;\n  right: 0;\n  left: auto;\n  max-width: calc(100vw - 2rem);\n}\n/* Dropdown items are nowrap by default — let long notification strings wrap\n   inside the capped menu width. */\n.utility-nav >>> .dropdown-item {\n  white-space: normal;\n}\n\n.latest-release {\n  font-size: 0.6em;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-aed97bc8"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/components/navbar/App.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__